import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { apexConfig } from "./data";

export default function ApexPage() {
  return <CityPageTemplate config={apexConfig} />;
}